// The restaurant scope's wire types, hand-authored against
// server/src/models/roots.rs (Restaurant, Store, RestaurantMembership).

export type PortalRole = 'admin' | 'user';
export const ROLES: PortalRole[] = ['admin', 'user'];

/** GET/PUT /restaurants/{rid}. The PUT carries every field but the ids. */
export type Restaurant = {
  restaurantId: string;
  name: string;
  logoUrl: string | null;
  timezone: string;
  country: string;
  createdAt: string;
  updatedAt: string;
};
export type RestaurantInput = { name: string; logoUrl: string | null; timezone: string; country: string };

/** GET /restaurants/{rid}/stores. */
export type Store = {
  restaurantId: string;
  storeId: string;
  name: string;
  timezone: string;
  address: string;
  phoneE164: string;
  pickupEnabled: boolean;
  deliveryEnabled: boolean;
  dineInEnabled: boolean;
  temporarilyClosed: boolean;
  permanentlyClosed: boolean;
  dayCloseTime: string;
  createdAt: string;
  updatedAt: string;
};
/** POST /restaurants/{rid}/stores (super). No timezone = the server default. */
export type StoreCreate = { name: string; address: string; phoneE164: string; timezone?: string };

/** GET /restaurants/{rid}/users — a grant joined with the person. */
export type Membership = {
  restaurantId: string;
  restaurantName: string;
  userId: string;
  email: string;
  displayName: string | null;
  role: PortalRole;
  createdAt: string;
};

export const AU_TIMEZONES = [
  'Australia/Sydney', 'Australia/Melbourne', 'Australia/Brisbane',
  'Australia/Adelaide', 'Australia/Perth', 'Australia/Hobart', 'Australia/Darwin',
];

/** A store's operating state, the first thing the health snapshot says. */
export function storeState(s: Store): { state: 'open' | 'temporarily_closed' | 'permanently_closed'; label: string; dot: string } {
  if (s.permanentlyClosed) return { state: 'permanently_closed', label: 'permanently closed', dot: 'var(--danger)' };
  if (s.temporarilyClosed) return { state: 'temporarily_closed', label: 'temporarily closed', dot: 'var(--warn)' };
  return { state: 'open', label: 'trading', dot: 'var(--ok)' };
}
